import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import * as myDevice from "./helpers/deviceHelpers"

import {useAppUpdater} from "@/composables/useAppUpdater"
import {useRouter} from "vue-router"
import {initStores} from "@/helpers/function/initStores"
import {onMounted, ref} from "vue"
import useQuasar from 'quasar/src/composables/use-quasar.js';
import {useI18n} from "vue-i18n"
import {useCommonStore} from "@/stores/common";
import {hasMegaCookie, redirectToRenewIfPossible} from "@/helpers"

import CookieModal from "@/components/modals/CookieModal.vue"

// Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t } = useI18n()
const stores = initStores()
const router = useRouter()
const $q = useQuasar()
const commonStore = useCommonStore()

const showCookiesModal = ref<boolean>(false)

const myIcons: {[index: string]:string} = {
  // Social Icons
  'app:rs_facebook': 'img:/img/social/facebook.svg',
  'app:rs_linkedin': 'img:/img/social/linkedin.svg',
  'app:rs_twitter': 'img:/img/social/twitter.svg',
  'app:rs_instagram': 'img:/img/social/instagram.svg',
  // UI icons
  'app:arrow_right': 'img:/img/ui/arrow-right.svg',
  'app:close_top': 'img:/img/ui/close_top.svg',
  'app:checkbox_c': 'img:/img/ui/checkbox_c.svg',
  'app:checkbox_u': 'img:/img/ui/checkbox_u.svg',
  'app:checkbox_d': 'img:/img/ui/checkbox_d.svg',
  'app:checked': 'img:/img/ui/checked.svg',
  'app:checked_d': 'img:/img/ui/checked_d.svg',
  'app:check_yellow': 'img:/img/ui/check_yellow.svg',
  'app:conditions': 'img:/img/ui/conditions.svg',
  'app:filter': 'img:/img/ui/filter_yellowcircle.svg',
  'app:filter_stroke_c': 'img:/img/ui/filter_strokecircle.svg',
  'app:filter_stroke': 'img:/img/ui/filter_stroke.svg',
  'app:home': 'img:/img/ui/home.svg',
  'app:home_active': 'img:/img/ui/home_active.svg',
  'app:usage': 'img:/img/ui/usage.svg',
  'app:usage_active': 'img:/img/ui/usage_active.svg',
  'app:bills': 'img:/img/ui/bills.svg',
  'app:bills_active': 'img:/img/ui/bills_active.svg',
  'app:subscription': 'img:/img/ui/subscription.svg',
  'app:subscription_active': 'img:/img/ui/subscription_active.svg',
  'app:more': 'img:/img/ui/more.svg',
  'app:expand': 'img:/img/ui/expand.svg',
  'app:expanded': 'img:/img/ui/expanded.svg',
  'app:previous': 'img:/img/ui/previous.svg',
  'app:previous_filled': 'img:/img/ui/previous_filled.svg',
  'app:work': 'img:/img/ui/work.svg',
}

// Stop error resizeObserver
// Found in https://github.com/vuejs/vue-cli/issues/7431

const debounce = (callback: (...args: any[]) => void, delay: number) => {
  let tid: any;
  return function (...args: any[]) {
    const ctx = self;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
        callback.apply(ctx, args);
      }, delay);
    };
};

const _ = (window as any).ResizeObserver;
  (window as any). ResizeObserver = class ResizeObserver extends _ {
    constructor(callback: (...args: any[]) => void) {
    callback = debounce (callback, 20);
    super(callback);
  }
};

// Include app updater dialog

useAppUpdater()

// Events

onMounted(() => {
  const authStore = stores.authStore;

  myDevice.setDeviceId() 
  myDevice.setDeviceKey()
  if (authStore.isAuthenticated) {
    authStore.checkExpired().then((value) => {
      if (value) {
        const redirectTo = redirectToRenewIfPossible({ fallBackToLogin: true }, authStore)
        if (redirectTo && router?.currentRoute.value.name?.toString() !== redirectTo.name) {
          authStore.logout(redirectTo.name !== 'login-main')
          router.push(redirectTo)
        }
      }
    }).catch((error) => {
      console.error(error)
      if (!authStore.userId || authStore.userId <= 0) {
        // Fallback => if we don't have user information then logout + redirect.
        authStore.logout()
        router.push({ name: 'login-main' })
      }
    })
  } else {
    const redirectTo = redirectToRenewIfPossible({}, authStore)
    if (redirectTo && router?.currentRoute.value.name?.toString() !== redirectTo.name) {
      router.push(redirectTo)
    }
  }

  $q.iconMapFn = (iconName: string) => {
    const icon = myIcons[iconName]
    if (icon !== void 0) {
      return { icon: icon }
    }
  }


  if (!hasMegaCookie() && !commonStore.isIos) {
    showCookiesModal.value = true
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (showCookiesModal.value)
      ? (_openBlock(), _createBlock(CookieModal, {
          key: 0,
          isDesktop: !_unref(stores).commonStore.isMobile,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showCookiesModal.value=false))
        }, null, 8, ["isDesktop"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_inner_loading, {
      class: "my-loading",
      showing: _unref(stores).commonStore.globalLoading
    }, {
      default: _withCtx(() => [
        (_unref(stores).commonStore.spinnerVisible)
          ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
              key: 0,
              size: "50px",
              color: "primary"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["showing"])
  ], 64))
}
}

})